// About page content.
//
// Shared between web and mobile. Paragraphs can be plain strings or arrays of
// runs to support inline links.
//
//   string                                 -> simple paragraph
//   [{ text }, { text, href }, ...]        -> paragraph with inline link runs
export const aboutContent = {
    title: 'About',
    sections: [
        {
            paragraphs: [
                'WineryXplorer was built for people who love discovering great wine — not fighting algorithms, ads, and pay-to-play rankings. We help wine lovers find wineries they’ll genuinely love, and help wineries connect with the kinds of guests who will appreciate what makes them special.',
                'By combining thoughtful curation, AI-powered recommendations, and personalized itineraries, WineryXplorer makes exploring wine country more personal, approachable, and memorable.',
                [
                    {
                        text: 'We are just as tired as you are of platforms becoming endless ads. We are serious about our no “',
                    },
                    {
                        text: 'enshittification',
                        href: 'https://doctorow.medium.com/my-mcluhan-lecture-on-enshittification-ea343342b9bc',
                    },
                    {
                        text: '” pledge. No endless sponsored listings pretending to be recommendations (we see you, Yelp and TripAdvisor), no pages covered in ads you don’t care about. Just great wineries, authentic experiences, and better ways to discover wine country.',
                    },
                ],
            ],
        },
        {
            heading: 'About the Founders',
            paragraphs: [
                'WineryXplorer has been rattling around in Mitch Kahn’s brain for at least a decade. On his first date with his now wife (to Napa!), he wished he had some app that could help him find wineries they’d like. Yelp was useless, Google Places not much better. He wanted a way to find the hidden gems and avoid the tourist traps and, honestly, lousy (yet expensive) wine. Years of off-again, on-again prototyping ensued, and then came AI. Now he had a way to not only code fast, but also accurately predict what users and wineries want: a wine “love connection.”',
                'Mitch and his wife are passionate wine collectors who have built a cellar of more than 1,000 bottles featuring many of Napa and Sonoma’s most celebrated wines — with a little French mixed in.',
                'They split their time between Napa and Silicon Valley, where Mitch has spent the last 20 years of his career building technology products and companies ranging from startups to global brands. Over the years, his teams have developed more than 50 applications for companies including Google, YouTube, StubHub and more. Most recently, Mitch worked at Amazon before leaving “big tech” to pursue greener pastures (vineyards, tbh).',
            ],
        },
    ],
};
